const AccessErrorImage = () => {
    return (
        <svg
            width="247"
            height="173"
            viewBox="0 0 247 173"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="54"
                y="6"
                width="140"
                height="140"
                rx="70"
                fill="#FEEDED"
            />
            <path
                d="M147.75 70.1111C146.133 70.1111 145.056 69.0333 145.056 67.4167V53.9444H131.583C129.967 53.9444 128.889 52.8667 128.889 51.25C128.889 49.6333 129.967 48.5555 131.583 48.5555H147.75C149.367 48.5555 150.444 49.6333 150.444 51.25V67.4167C150.444 69.0333 149.367 70.1111 147.75 70.1111ZM99.25 70.1111C97.6334 70.1111 96.5556 69.0333 96.5556 67.4167V51.25C96.5556 49.6333 97.6334 48.5555 99.25 48.5555H115.417C117.033 48.5555 118.111 49.6333 118.111 51.25C118.111 52.8667 117.033 53.9444 115.417 53.9444H101.944V67.4167C101.944 69.0333 100.867 70.1111 99.25 70.1111ZM115.417 102.444H99.25C97.6334 102.444 96.5556 101.367 96.5556 99.75V83.5833C96.5556 81.9667 97.6334 80.8889 99.25 80.8889C100.867 80.8889 101.944 81.9667 101.944 83.5833V97.0555H115.417C117.033 97.0555 118.111 98.1333 118.111 99.75C118.111 101.367 117.033 102.444 115.417 102.444ZM147.75 102.444H131.583C129.967 102.444 128.889 101.367 128.889 99.75C128.889 98.1333 129.967 97.0555 131.583 97.0555H145.056V83.5833C145.056 81.9667 146.133 80.8889 147.75 80.8889C149.367 80.8889 150.444 81.9667 150.444 83.5833V99.75C150.444 101.367 149.367 102.444 147.75 102.444Z"
                fill="#EF4444"
            />
            <path
                opacity="0.5"
                d="M115.417 70.1111H131.583C134.547 70.1111 136.972 72.5361 136.972 75.5V86.2778C136.972 89.2417 134.547 91.6667 131.583 91.6667H115.417C112.453 91.6667 110.028 89.2417 110.028 86.2778V75.5C110.028 72.5361 112.453 70.1111 115.417 70.1111ZM120.806 67.4167C120.806 65.8 121.883 64.7222 123.5 64.7222C125.117 64.7222 126.194 65.8 126.194 67.4167V70.1111H131.583V67.4167C131.583 62.8361 128.081 59.3333 123.5 59.3333C118.919 59.3333 115.417 62.8361 115.417 67.4167V70.1111H120.806V67.4167Z"
                fill="#EF4444"
            />
            <g filter="url(#filter0_d_2578_7751)">
                <rect
                    x="145"
                    y="112"
                    width="39"
                    height="39"
                    rx="19.5"
                    fill="white"
                    shape-rendering="crispEdges"
                />
                <rect
                    x="145.652"
                    y="112.652"
                    width="37.6957"
                    height="37.6957"
                    rx="18.8478"
                    stroke="#FCDADA"
                    stroke-width="1.30435"
                    shape-rendering="crispEdges"
                />
                <path
                    d="M164.5 121C158.65 121 154 125.65 154 131.5C154 137.35 158.65 142 164.5 142C170.35 142 175 137.35 175 131.5C175 125.65 170.35 121 164.5 121ZM168.55 136.75L164.5 132.7L160.45 136.75L159.25 135.55L163.3 131.5L159.25 127.45L160.45 126.25L164.5 130.3L168.55 126.25L169.75 127.45L165.7 131.5L169.75 135.55L168.55 136.75Z"
                    fill="#EF4444"
                />
            </g>
            <defs>
                <filter
                    id="filter0_d_2578_7751"
                    x="130.652"
                    y="98.9565"
                    width="67.6957"
                    height="67.6957"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="1.30435" />
                    <feGaussianBlur stdDeviation="7.17391" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.694118 0 0 0 0 0.694118 0 0 0 0 0.694118 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_2578_7751"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_2578_7751"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    )
}

export default AccessErrorImage
